import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import Button from "../Button/Button";

type PageBackButtonProps = {
  fallbackTo: string;
  label: string;
  className?: string;
};

const hasInternalHistoryEntry = () => {
  if (typeof window === "undefined") {
    return false;
  }

  const historyState = window.history.state as { idx?: number } | null;
  return typeof historyState?.idx === "number" && historyState.idx > 0;
};

const PageBackButton = ({ fallbackTo, label, className }: PageBackButtonProps) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (hasInternalHistoryEntry()) {
      navigate(-1);
      return;
    }

    navigate(fallbackTo, { replace: true });
  };

  return (
    <div className={clsx("flex justify-center sm:justify-start", className)}>
      <Button
        type="button"
        variant="tertiary"
        size="sm"
        onClick={handleBack}
        className="inline-flex max-w-full items-center gap-2 rounded-full border border-myteengig-border bg-white px-3 py-2 text-left text-myteengig-text-primary hover:bg-myteengig-background sm:px-4"
      >
        <svg
          aria-hidden="true"
          viewBox="0 0 16 16"
          className="h-4 w-4 shrink-0"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M10.5 3.5 6 8l4.5 4.5" />
          <path d="M6.5 8h6" />
        </svg>
        <span className="leading-tight">{label}</span>
      </Button>
    </div>
  );
};

export default PageBackButton;
